import React from 'react';

export default function OR() {
  return (
    <div className="flex h-[50px] w-[50px] items-center justify-center rounded-full bg-v5-green-100 font-bold italic text-v5-green-700">
      <div className="mr-1">OR</div>
    </div>
  );
}
